<template>
  <div>

    <a class="issue-notifications-registration-page-url" :href="issueNotificationsLoginPageUrl">{{issueNotificationsLoginPageLinkText}}</a>
    
    <div class="panel notice" v-if="hasSelectedIssueInformation()">
      <div v-if="hasSelectedIssueInformation()">
        <h2 class="panel-title">{{NotificationPopupHeading}}</h2>
        <p>{{ProceedingTitle}}</p>
      </div>
      <div v-if="hasSelectedCommitteeInformation()">
        <h2 class="panel-title">{{NotificationPopupHeading}}</h2>
        <p>{{CommitteeTitle}}</p>
      </div>
    </div>

    <div class="article-excerpt" v-html="Ingress"></div>
    <div v-html="MainBody" class="block-article block-article-mobile"></div>

    <div aria-live="polite">
      <div v-if="!showNewContactEmailSentConfirmation">
        <h2 id="registration-form-heading">{{EmailHeading}}</h2>

        <div v-if="showNewContactError">
          <div class="panel alarmbanner">
            <p>
              {{newContactErrorMessage}}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="medium-6 columns form-area">
            <p>
              <input v-model="newEmail" type="email" :placeholder="EmailPlaceholder" aria-labelledby="registration-form-heading">
            </p>
            <span class="checkbox-fullwidth">
              <input type="checkbox" name="gdpr-consent-checkbox-register-new-user" id="gdpr-consent-checkbox-register-new-user" v-model="gdpr.consentGiven.registerNewUser" />
              <label for="gdpr-consent-checkbox-register-new-user">
                {{gdpr.consentText}} <a :href="gdpr.privacyPolicyUrl">{{gdpr.privacyPolicyLinkText}}</a>
              </label>
            </span>
            <p v-html="this.$root.dataRecaptchaInformationText"></p>
          </div>
        </div>
        <p>
          <div class="issue-notification-cta-container">
            <img v-if="working" class="loader-gif" src="/Web/FrontEndR/assets/gfx/loader-transparent.gif" />
            <button type="button" class="button submit" @click="submitWithRecaptcha(registerUser)" :disabled="this.registrationTriggered === true || this.newEmail === '' || !gdpr.consentGiven.registerNewUser">
              <span>{{CreateSubscriptionButtonText}}</span>
            </button>
          </div>
        </p>
      </div>
      <div v-else>
        <div class="panel notice">
          <div v-html="SubscriptionConfirmationPopupText"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import FetchService from './fetchService';

  export default {
    name: 'issue-notifications-registration',
    data() {
      return {
        SubscriptionType: this.getQueryStringParameter('vt'),
        ProceedingTitle: this.$root.data.ProceedingTitle,
        ProceedingIdString: this.$root.data.ProceedingIdString,
        CommitteeTitle: this.$root.data.CommitteeTitle,
        CommitteeIdString: this.$root.data.CommitteeIdString,
        NotificationPopupHeading: this.$root.data.NotificationPopupHeading,
        Ingress: this.$root.data.Ingress,
        MainBody: this.$root.cmsDataMainBody,
        SubscriptionConfirmationPopupText: this.$root.cmsDataCreateSubscriptionConfirmationPopupText,
        EmailHeading: this.$root.data.EmailHeading,
        EmailPlaceholder: this.$root.data.EmailPlaceholder,
        CreateSubscriptionButtonText: this.$root.data.CreateSubscriptionButtonText,
        newEmail: '',
        showNewContactEmailSentConfirmation: false,
        registrationTriggered: false,
        showNewContactError: false,
        newContactErrorMessage: this.$root.data.createNewContactErrorMessage,
        issueNotificationsLoginPageLinkText: this.$root.data.issueNotificationsLoginPageLinkText,
        issueNotificationsLoginPageUrl: this.$root.data.issueNotificationsLoginPageUrl,
        gdpr: {
          consentText: this.$root.data.GdprConsent.Text,
          privacyPolicyUrl: this.$root.data.GdprConsent.PrivacyPolicyUrl,
          privacyPolicyLinkText: this.$root.data.GdprConsent.PrivacyPolicyLinkText,
          consentGiven: {
            registerNewUser: false
          }
        },
        working: false
      };
    },
    methods: {
      registerUser: function (recaptchaToken) {
        this.working = true;
        this.showNewContactError = false;
        this.registrationTriggered = true;

        if (!recaptchaToken) {
          this.showNewContactError = true;
          return;
        }

        let data = this.createRequestData(this.newEmail, recaptchaToken);

        FetchService.post('contact/CreateNewContact/', data, { includeCredentials: true })
          .then(() => {
            this.showNewContactEmailSentConfirmation = true;
          })
          .catch(() => {
            this.registrationTriggered = false;
            this.showNewContactError = true;
          })
          .finally(() => {
            this.working = false;
          });
      },
      getCurrentLanguage() {
        return document.querySelector('html').getAttribute('lang');
      },
      getQueryStringParameter(parameterName) {
        let result = null;
        let temp = [];

        location.search
          .substr(1)
          .split('&')
          .forEach(function (item) {
            temp = item.split('=');
            if (temp[0] === parameterName) result = decodeURIComponent(temp[1]);
          });

        return result;
      },
      createRequestData(email, recaptchaToken) {
        let lang = this.getCurrentLanguage();
        let data = {
          email: email,
          lang: lang,
          recaptchaToken: recaptchaToken
        };

        if (this.hasSelectedIssueInformation()) {
          data.subscriptionId = this.ProceedingIdString;
          data.subscriptionType = this.SubscriptionType;
        }

        if (this.hasSelectedCommitteeInformation()) {
          data.subscriptionId = this.CommitteeIdString;
          data.subscriptionType = this.SubscriptionType;
        }

        return data;
      },
      hasSelectedIssueInformation() {
        console.log('hasSelectedIssueInformation', this.ProceedingIdString, this.ProceedingTitle);
        return this.ProceedingIdString && this.ProceedingTitle && this.SubscriptionType;
      },
      hasSelectedCommitteeInformation() {
        console.log('hasSelectedCommitteeInformation', this.CommitteeIdString, this.CommitteeTitle);
        return this.CommitteeIdString && this.CommitteeTitle && this.SubscriptionType;
      },
      submitWithRecaptcha(callback) {
        if (!this.$root.data.recaptchaSiteKey) {
          throw 'Missing recaptcha site key.';
        }

        if (!this.$root.data.recaptchaAction) {
          throw 'Missing recaptcha action.';
        }

        if (!window.grecaptcha) {
          throw 'Grecaptcha is undefined.';
        }

        window
          .grecaptcha
          .execute(this.$root.data.recaptchaSiteKey, { action: this.$root.data.recaptchaAction })
          .then(callback);
      }
    }
  };
  
</script>



// WEBPACK FOOTER //
// IssueNotificationsRegistration.vue?3c8da97f